<template>
    <v-app>
        <v-app-bar app color="#2f80e2" dark>
            <v-img v-if="$vuetify.breakpoint.mdAndUp" alt="Norbotics logo" class="shrink" contain src="./assets/norbotics_logo_invertion.svg" transition="scale-transition" />
            <v-img v-else alt="Norbotics logo" height="32px" width="32px" class="shrink" src="./assets/norbotics-favicon-white.png" transition="scale-transition" />

            <!-- <div class="grow"></div> -->
            <v-spacer></v-spacer>

            <v-select v-model="selectedLanguage" :items="languages" dense hide-details style="max-width: 100px;">
                <template v-slot:item="{item}">
                    <div class="d-flex">
                        <v-img height="21px" width="24px" :src="require(`./assets/${item.src}`)"></v-img>
                        <div class="mx-1"></div>
                        <div :class="{'font-weight-bold': item == selectedLanguage}">
                            {{item.long}}
                        </div>
                    </div>
                </template>

                <template v-slot:selection="{item}">
                    <div class="d-flex">
                        <v-img height="18px" width="22px" :src="require(`./assets/${item.src}`)"></v-img>
                        <div class="mx-1"></div>
                        <div class="ma-0">
                            {{item.short}}
                        </div>
                    </div>
                </template>
            </v-select>

            <v-divider vertical class="ml-2"></v-divider>

            <v-btn class="shrink pa-0 ma-0" href="https://norbotics.com" target="_blank" text>
                <span class="mx-2 text-md-body-1 text-body-2">Gatebrains portal</span>
                <v-icon>mdi-open-in-new</v-icon>
            </v-btn>
        </v-app-bar>

        <v-content>
            <!-- <v-container fluid> -->
            <router-view></router-view>
            <!-- </v-container> -->

        </v-content>

        <!-- #1f1633 -->
        <v-footer app color="#2f80e2" dark :height="$vuetify.breakpoint.smAndDown? '125px': ''">
            <v-row align="center" justify="center" no-gutters>
                <v-col align="center">
                    <v-img src="./assets/norbotics_logo_invertion.svg" contain max-width="200"></v-img>
                    <!-- <div class="mt-5">Norbotics AS</div> -->
                    <div :class="{'mt-3': $vuetify.breakpoint.smAndUp, 'mt-1': $vuetify.breakpoint.sxOnly}">
                        <v-btn icon href="mailto:info@norbotics.no">
                            <v-icon>mdi-email</v-icon>
                        </v-btn>

                        <v-btn icon href="https://www.facebook.com/norbotics" target="_blank">
                            <v-icon>mdi-facebook</v-icon>
                        </v-btn>

                        <v-btn icon href="https://no.linkedin.com/company/norbotics?trk=public_profile_topcard_current_company" target="_blank">
                            <v-icon>mdi-linkedin</v-icon>
                        </v-btn>

                        <v-btn icon href="https://twitter.com/NorboticsAS" target="_blank">
                            <v-icon>mdi-twitter</v-icon>
                        </v-btn>

                        <v-btn icon href="https://www.instagram.com/norbotics_as/" target="_blank">
                            <v-icon>mdi-instagram</v-icon>
                        </v-btn>

                    </div>

                    <div class="mt-0 body-2">
                        <v-row no-gutters>
                            <v-col cols="12" sm="6" :class="{'text-right': $vuetify.breakpoint.smAndUp}">Copyright {{date}} Norbotics</v-col>
                            <v-col cols="12" sm="6" :class="{'text-left': $vuetify.breakpoint.smAndUp}"> <span v-if="$vuetify.breakpoint.smAndUp" class="mx-1">-</span>Made by Norbotics</v-col>
                        </v-row>
                    </div>
                </v-col>
            </v-row>

        </v-footer>
    </v-app>
</template>

<script>
// import HelloWorld from './components/HelloWorld';
import * as moment from "moment";
import { mapState } from "vuex";

export default {
    name: "App",

    //   components: {
    //     HelloWorld,
    //   },

    data: () => ({
        date: moment().format("YYYY")
    }),
    computed: {
        ...mapState({
            languages: "languages",
        }),
        selectedLanguage: {
            get: function() {
                return this.$store.getters.selectedLanguage;
            },
            set: function(language) {
                this.$store.commit("selectedLanguage", language);
            }
        }
    },
    mounted() {
        let language = this.languages.find(language => language.short == "NO");
        this.$set(this, "selectedLanguage", language);
    }
};
</script>

<style lang="scss">
.about {
    width: 100%;
    height: 100%;
    background-color: #2f7fe2;
}
.overlay {
    width: 100%;
    height: 100%;
    background-image: url("./assets/background_004.svg");
    background-repeat: repeat;
    background-size: 10% auto;
    background-position: center center;
    opacity: 9%;
    transition: background 0.3s, border-radius 0.3s, opacity 0.3s;
}
</style>
